// src/js/lightbox-manager.js
const lightbox = document.getElementById('clhb-global-lightbox');
const contentArea = lightbox.querySelector('.clhb-lightbox-content');

lightbox.querySelector('.clhb-lightbox-close').addEventListener('click', () => {
    closeLightbox();
});

export const openLightbox = (contentHTML) => {
    if (typeof contentHTML == "object") {
        contentArea.replaceChildren(contentHTML);
    } else {
        contentArea.innerHTML = contentHTML;
    }
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden'; // Empêche le scroll du fond
};

export const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = ''; // Restaure le scroll
    // Petit délai pour vider le contenu après l'animation de fermeture CSS
    setTimeout(() => { contentArea.innerHTML = ''; }, 300);
};